<template>
  <div class="steps">
    <div class="line-bg show-on-pad"></div>
    <div class="line show-on-pad" :style="{ width: getLineWidth }"></div>
    <div 
      class="step-item" 
      v-for="(item,index) in steparr"
      :key="index+'_step_item'"
      :class="{ active:step>=(index+1) }"
    ><span class="step-title hide-on-pad">{{ prefix?`STEP${index+1}`:'' }}{{ item }}</span><span class="step-index show-on-pad-flex">{{ index+1 }}</span></div>
    <!-- <div class="step-item" :class="{ active:step>='2' }"><span class="step-title hide-on-pad">STEP2确认变更资料</span><span class="step-index show-on-pad-flex">2</span></div>
    <div class="step-item" :class="{ active:step>='3' }"><span class="step-title hide-on-pad">STEP3完成变更</span><span class="step-index show-on-pad-flex">3</span></div> -->
  </div>
</template>

<script>
  export default {
    name: 'step',
    props: {
      step: {
        type: Number,
        default: 1,
      },
      steparr: {
        type: Array,
        default: () => []
      },
      prefix: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      getLineWidth() {
        switch(this.step) {
          case 1:
            return '30px';
            break;
          case 2:
            return '49%';
            break;
          case 3:
            return 'calc(100% - 32px)';
            break;
        }
      },
    }
  }
</script>

<style lang="less" scoped>
.steps {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  padding-left: 30%;
  position: relative;
  .step-item {
    font-weight: 400;
    color: #707070;
    &.active {
      color: #FF5214;

    }
  }
  @media (max-width: 992px) {
    padding-left: 0%;
    padding: 0 16px;
    border-bottom: unset;
    .line {
      position: absolute;
      width: calc(100% - 32px);
      height: 3px;
      background: #FF5214;
      border-radius: 3px;
      z-index: -1;
      top: 50%;
      transform: translateY(-50%);
    }
    .line-bg {
      position: absolute;
      width: calc(100% - 32px);
      height: 3px;
      background: #F5F4F8;
      border-radius: 3px;
      z-index: -1;
      top: 50%;
      transform: translateY(-50%);
    }
    .step-item:nth-child(3) {
      margin-left: 30px;
    }
    .step-item:nth-last-child(1) {
      margin-right: 30px;
    }
    .step-index {
      background: white;
      color:#E6E6E6;
      width: 28px;
      height: 28px;
      border-radius: 50%;
      border: 2px solid #E6E6E6;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      &::after {
        content: '';
        position: absolute;
        height: 28px;
        width: 28px;
        left: -5px;
        top: -5px;
        border: 3px solid white;
        border-radius: 50%;
      }
    }
    .step-item {
      font-weight: 400;
      color: #707070;
      &.active {
        .step-index {
          background: #FF5214;
          border: 2px solid #FF5214;
          color: white;
        }
      }
    }
  }
}
</style>